import { useMutation, useQuery } from "react-query";
import * as ordersService from 'services/ordersService';
import { ListOrdersDto } from "types/dto/ListOrdersDto";


export const useGetOrders = (dto: ListOrdersDto, options = {}) => {
  return useQuery({
    queryKey: ['orders', dto],
    queryFn: () => ordersService.getOrders(dto),
    ...options
  });
}

export const useSendReviewReminders = (
  onSuccess?: (response: { customers: number }) => void,
  onError?: (error: any) => void,
  options = {}
) => {
  return useMutation(ordersService.sendReviewReminders, {
    onSuccess,
    onError,
    ...options,
  });
};

